import { allLeaveRequestConstans } from "../constant/allLeaveRequest.constants";

export const initialState = {
    allLeaveRequest: [],
    errorCode: "",
    successCode: "",
    searching: false,
    isLoading: false,
};
const allLeaveRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case allLeaveRequestConstans.GET_REQUEST_LIST:
            return {
                ...state,
                searching: true,
            };
        case allLeaveRequestConstans.GET_REQUEST_LIST_PAGE:
            return {
                ...state,
                isLoading: true,
            };
        case allLeaveRequestConstans.GET_REQUEST_LIST_SUCCESS:
            return {
                ...state,
                allLeaveRequest: action.listRequest,
                searching: false,
                isLoading: false,
            };
        default:
            return state;
    }
};

export default allLeaveRequestReducer;
